export const validateUTMCampaign = utmCampaign => {
  /**
   * utmCampaign needs to be the ID of an Email or SMS campaign
   * Thus each character needs to be a number
   */
  if (!utmCampaign) {
    return null;
  }

  for (const char of utmCampaign) {
    if (isNaN(char)) {
      return null;
    }
  }
  return utmCampaign;
};
